import React from 'react';
import UnsubIcon from '@/assets/images/unsubscribed.svg';
import SubExpiredIcon from '@/assets/images/sub-expired.svg';
import { useTranslation } from 'react-i18next';

const SubscriptionChecker = ({ unsubscribed = false, expired = false }) => {
	const { t } = useTranslation('general');
	return (
		<div className="text-center">
			{unsubscribed && (
				<>
					<div
						className="d-flex align-items-center justify-content-center"
						style={{ height: '180px' }}
					>
						<img src={UnsubIcon} alt="Unsubscribed Logo" height="180" />
					</div>
					<h1>{t('general:subscription.notSubscribed')}</h1>
					<h3>{t('general:subscription.contact')}</h3>
				</>
			)}
			{expired && (
				<>
					<div
						className="d-flex align-items-center justify-content-center"
						style={{ height: '180px' }}
					>
						<img src={SubExpiredIcon} alt="Expired Icon" height="180" />
					</div>
					<h1>{t('general:subscription.expired')}</h1>
					<h3>{t('general:subscription.renewContact')}</h3>
				</>
			)}
		</div>
	);
};

export default SubscriptionChecker;
